import { config } from "./config";
import { attribute as gtm } from "./gtm";
export var content = {
    generalErrorTitle: "Error",
    generalErrorMessage: "Er ging iets mis.",
    pageNotFoundMessage: "Deze pagina bestaat niet.",
    loading: "",
    error4xx: function () { return ({
        title: "Oeps, er ging iets mis",
        message: "We hebben de pagina die je zoekt niet gevonden.",
        callToAction: {
            label: "Ga naar de homepagina",
            url: "/",
        },
    }); },
    error5xx: function (currentUrl) { return ({
        title: "Oeps, er ging iets mis",
        message: "We ondervinden momenteel enkele problemen. Probeer te pagina de herladen of kom later terug.",
        callToAction: {
            label: "Probeer opnieuw",
            url: currentUrl,
        },
    }); },
    fromDateOn: function (date) { return ({
        label: "Vanaf ".concat(date, " bij"),
    }); },
    movieDateOn: function (date) { return ({
        label: "".concat(date, " bij"),
    }); },
    goToHomepage: "Ga naar de hoofdpagina",
    goToProgramPrefix: "Ga naar",
    vtmgoLive: "Nu live op",
    vtmgoOnDemand: "Kijk op",
    vtmgoPlusOnDemand: "Nu al op",
    today: "Vandaag",
    tonight: "Vanavond",
    tomorrow: "Morgen",
    dayAfterTomorrow: "Overmorgen",
    live: "Live",
    card: {
        Article: "Lees hier het artikel",
        Video: "Bekijk nu de video",
        BasicPage: "Bekijk hier",
        Contest: "Bekijk hier",
        Participate: "Doe nu mee",
        Interactive: "Doe nu mee",
        ContentCollectionContinuousHorizontal: "ContentCollectionContinuousHorizontal",
        DynamicHero: "DynamicHero",
        HomePage: "HomePage",
        Program: "Ga naar het programma",
        Slug: "Slug",
    },
    contestLabel: "Wedstrijd",
    weekday: {
        monday: "Maandag",
        tuesday: "Dinsdag",
        wednesday: "Woensdag",
        thursday: "Donderdag",
        friday: "Vrijdag",
        saturday: "Zaterdag",
        sunday: "Zondag",
        unknown: "Onbekend",
    },
    months: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "november",
    ],
    episodes: {
        goPlusButton: {
            label: "Nu al op",
        },
        goButton: {
            label: "Kijk op",
        },
        listButton: {
            label: "Mijn lijst",
        },
    },
    deadlineHasPassed: "Deadline has passed.",
    playerDataNoJson: "The player data was not JSON.",
    noPlayerData: "There was no player data",
    noPlayerHtml: "There was no player html",
    title: {
        popularPrograms: {
            prefix: "",
            strong: "Populair bij VTM",
            suffix: "",
        },
        popularOnVtm: "Deze programma's moet je nu zien",
        recentVideos: "Nieuwste fragmenten",
        highlights: "In de kijker",
        experienceHighlights: "Doe mee",
        videoPlaylist: "Recent nieuws",
        allPrograms: "Alle content",
        programSearchResults: "Zoekresultaten",
        comingSoonPrograms: "Binnenkort",
        movies: "Films",
    },
    programPage: {
        ticketHighlight: {
            cta: {
                title: "Reserveer je plaats",
            },
        },
    },
    homePage: {
        topPicksTitle: "Deze week op VTM",
        topPicksFullGuideLink: {
            url: "/tv-gids",
            title: "Naar de volledige TV-Gids",
        },
        topPicksLiveLabel: "Live op",
    },
    programsPage: {
        tracking: {
            title: "Programma's",
            type: "program overview",
        },
        popularTitle: "In de kijker",
        onAirTitle: "Nu bij VTM",
        comingSoonTitle: "Binnenkort bij VTM",
        seasonLane: {
            title: "Volledige afleveringen op",
            ctaLabel: "Naar het volledige seizoen",
            fallbackImage: {
                alt: "VTM Go fallback visual",
            },
        },
        search: {
            placeholder: {
                desktop: "Zoek een programma, film, ...",
                mobile: "Zoek een programma, ...",
            },
            noResults: "Geen resultaten gevonden",
        },
        comingSoonWithAppendedLogo: "Binnenkort bij",
        comingSoon: "Binnenkort",
    },
    mainNav: {
        home: {
            label: "Home",
            url: config.slugs.root,
            gtm: gtm.mainNav.home,
        },
        tickets: {
            label: "Doe mee",
            url: config.slugs.tickets,
            gtm: gtm.mainNav.tickets,
        },
        programs: {
            label: "Programma's",
            url: config.slugs.programs,
            gtm: gtm.mainNav.programmas,
        },
        tvGuide: {
            label: "TV-gids",
            url: config.slugs.tvGuide,
            gtm: gtm.mainNav.tvGids,
        },
        vtmGo: {
            label: "Kijk op",
            url: "https://www.vtmgo.be",
            gtm: gtm.mainNav.vtmGo,
            tracking: {
                name: "Kijk op VTM GO",
                variant: "VTM GO home",
            },
        },
        shop: {
            label: "Shop",
            url: "https://shop.vtm.be",
            urlTarget: "_blank",
            gtm: gtm.mainNav.vtmShop,
        },
    },
    shop: {
        icon: "/icons/icon-shop.svg",
    },
    userBadge: {
        loggedOut: {
            navItem: {
                label: "Aanmelden",
                gtm: gtm.userBadge.loggedOut.navItem,
            },
            callToAction: {
                label: "Aanmelden",
                gtm: gtm.userBadge.loggedOut.callToAction,
            },
            register: {
                label: "Maak een VTM account",
                url: "https://google.be",
                gtm: gtm.userBadge.loggedOut.register,
            },
        },
        loggedIn: {
            navItem: {
                gtm: gtm.userBadge.loggedIn.navItem,
            },
            defaultGreeting: "Gebruiker",
            callToAction: {
                label: "Profiel",
            },
            settings: {
                label: "Accountinstellingen",
                url: "https://mijnomgeving.vtm.be/",
                target: "_blank",
                gtm: gtm.userBadge.loggedIn.settings,
            },
            logout: {
                label: "Afmelden",
                gtm: gtm.userBadge.loggedIn.logout,
            },
        },
    },
    search: {
        navItem: {
            label: "Zoeken",
            gtm: gtm.mainNav.search,
        },
        icon: "/icons/icon-header-search.svg",
        close: {
            label: "Sluiten",
        },
        clear: {
            label: "Clear",
        },
        page: {
            title: "Zoekresultaten",
            placeholder: {
                desktop: "Zoek een programma, ...",
                mobile: "Zoek een programma, ...",
            },
            noResultsTitle: "Geen resultaten gevonden voor deze zoekopdracht",
            errorMessage: "Er ging iets mis.",
        },
        resultType: {
            progam: "Programma",
        },
    },
    banner: {
        close: {
            alt: "Close Banner",
            label: "Sluiten",
        },
        error: "Oeps, er ging is mis. Probeer opnieuw.",
    },
    brands: {
        vtmGo: {
            imageUrl: "/images/logos/vtm-go-2.svg",
            alt: "vtmGo",
            url: "https://www.vtmgo.be/",
            urlTarget: "_blank",
        },
        vtmNieuws: {
            imageUrl: "/images/logos/vtm-nieuws.svg",
            alt: "vtmNieuws",
            url: "/vtm-nieuws",
            urlTarget: "_self",
        },
        vtmKids: {
            imageUrl: "/images/logos/vtm-kids.svg",
            alt: "vtmKids",
            url: "https://www.vtmgo.be/studio100",
            urlTarget: "_blank",
        },
        vtmKoken: {
            imageUrl: "/images/logos/vtm-koken.svg",
            alt: "vtmKoken",
            url: "https://koken.vtm.be/",
            urlTarget: "_blank",
        },
        vtmShop: {
            imageUrl: "/images/logos/vtm-shop.svg",
            alt: "vtmShop",
            url: "https://shop.vtm.be/",
            urlTarget: "_blank",
        },
        vtmTickets: {
            imageUrl: "/images/logos/vtm-tickets.svg",
            alt: "vtmTickets",
            url: "/tickets",
            urlTarget: "_self",
        },
    },
    button: {
        vtmGo: {
            alt: "VTM GO - Het gratis videoplatform met de beste Vlaamse programma's",
        },
        vtmGoPlus: {
            alt: "VTM GO Plus - Premium streamingdienst met exclusieve content",
        },
        nieuws: {
            alt: "VTM Nieuws",
        },
    },
    footer: {
        companyDetails: "DPG Media NV - Mediaplein 1, 2018 Antwerpen",
        companyDetailsSecondline: "RPR Antwerpen nr. 0432.306.234",
        vtmGoBlock: {
            title: "Kijk live, uitgesteld of binge the night away!",
            text: "VTM GO is het gratis videoplatform met de beste Vlaamse programma's",
            button: {
                label: "Kijk op",
                url: "https://www.vtmgo.be",
                tracking: {
                    name: "Kijk op VTM GO",
                    variant: "VTM GO home",
                },
            },
            gtm: gtm.footerNav.vtmGo,
        },
        legal: [
            {
                label: "Gebruiksvoorwaarden",
                url: "https://www.dpgmedia.be/nl/gebruiksvoorwaarden",
            },
            {
                label: "Cookiebeleid",
                url: "https://www.dpgmedia.be/nl/cookiebeleid",
            },
            {
                label: "Privacybeleid",
                url: "https://www.dpgmedia.be/nl/privacy",
            },
            {
                label: "Toegankelijkheidsverklaring",
                url: "/toegankelijkheidsverklaring-website",
            },
            {
                label: "Wedstrijdreglement",
                url: "https://www.dpgmedia.be/nl/wedstrijdreglement",
            },
        ],
        cookie: {
            label: "Cookie instellingen",
            url: "#",
        },
        nav: {
            socials: {
                facebook: {
                    url: "https://www.facebook.com/vtm",
                    gtm: gtm.footerNav.facebook,
                },
                instagram: {
                    url: "https://www.instagram.com/vtm.be",
                    gtm: gtm.footerNav.instagram,
                },
            },
            items: [
                {
                    label: "Programma's",
                    url: config.slugs.programs,
                    gtm: gtm.footerNav.programmas,
                },
                {
                    label: "TV-gids",
                    url: config.slugs.tvGuide,
                    gtm: gtm.footerNav.tvGids,
                },
                {
                    label: "Doe mee",
                    url: config.slugs.tickets,
                    gtm: gtm.footerNav.doeMee,
                },
                {
                    label: "Adverteren",
                    url: "https://www.advertising.dpgmedia.be/nl",
                    gtm: gtm.footerNav.adverteren,
                },
                {
                    label: "Route naar VTM",
                    url: "/route-naar-vtm",
                    gtm: gtm.footerNav.route,
                },
                {
                    label: "Jobs",
                    url: "https://www.dpgmediagroup.com/nl-BE/werken-bij-dpgmedia",
                    gtm: gtm.footerNav.jobs,
                },
                {
                    label: "FAQ",
                    url: "https://customerservice.vtm.be/hc/nl?_ga=2.10249653.1080990777.1598252525-518427902.1597671855",
                    gtm: gtm.footerNav.vragen,
                },
                {
                    label: "Nieuwsbrief",
                    url: "/nieuwsbrief",
                    gtm: gtm.footerNav.nieuwsbrief,
                },
            ],
        },
    },
    tvGuide: {
        tracking: {
            title: "TV Gids",
            type: "tv guide",
        },
    },
    browserNotSupported: {
        title: "Oeps, browser niet ondersteund",
        decription: "Voor je onze programma's gaat ontdekken, best je browser updaten of hieronder één van de ondersteunde browsers downloaden.",
        download: "Download",
        browsers: {
            Chrome: "Google Chrome",
            Firefox: "Firefox",
            Safari: "Safari",
            Edge: "Microsoft Edge",
            Opera: "Opera",
        },
        aria: {
            support: "Ondersteunde browsers",
            Chrome: "Download Google Chrome browser",
            Firefox: "Download Firefox browser",
            Safari: "Download Safari browser",
            Edge: "Download Microsoft Edge browser",
            Opera: "Download Opera browser",
        },
    },
    consent: {
        message: "Je cookie-instellingen zorgen ervoor dat deze inhoud niet getoond wordt.",
        cookies: "Cookie-instellingen aanpassen",
    },
    tickets: {
        blockTitle: "VTM Tickets",
        cta: "Reserveer je plaats",
    },
};
